export default "__VITE_ASSET__2546f5d7__"